module.exports = __webpack_public_path__ + "media/images/icons/flags/MH-37fe4bb0035c56a4ca4f419ede8f503f.svg";